<template>
    <div
        v-if="visible"
        class="environment-banner"
        :style="{backgroundColor: backgroundColor}"
        role="status"
        aria-live="polite"
    >
        <span class="environment-banner__text">{{ text }}</span>
    </div>
</template>

<script>
const DEFAULT_BANNER_HEIGHT = '32px';
const DEFAULT_BACKGROUND_COLOR = '#dc2626';
const HEX_COLOR_PATTERN = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

export default {
    name: "environment-banner",
    computed: {
        settings() {
            return this.$store && this.$store.state && this.$store.state.settings
                ? this.$store.state.settings
                : {};
        },
        text() {
            return String(this.settings.environment_banner_text || '').trim();
        },
        backgroundColor() {
            const color = String(this.settings.environment_banner_background_color || '').trim();

            return HEX_COLOR_PATTERN.test(color) ? color : DEFAULT_BACKGROUND_COLOR;
        },
        visible() {
            return !!this.settings.environment_banner_enabled && this.text.length > 0;
        },
    },
    watch: {
        visible: {
            immediate: true,
            handler() {
                this.syncDocumentState();
            },
        },
    },
    beforeUnmount() {
        this.clearDocumentState();
    },
    methods: {
        syncDocumentState() {
            if (typeof document === 'undefined') {
                return;
            }

            document.documentElement.classList.toggle('environment-banner-active', this.visible);
            if (this.visible) {
                document.documentElement.style.setProperty('--environment-banner-height', DEFAULT_BANNER_HEIGHT);
            } else {
                document.documentElement.style.removeProperty('--environment-banner-height');
            }
        },
        clearDocumentState() {
            if (typeof document === 'undefined') {
                return;
            }

            document.documentElement.classList.remove('environment-banner-active');
            document.documentElement.style.removeProperty('--environment-banner-height');
        },
    },
}
</script>

<style lang="scss">
.environment-banner {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 13000;
    display: flex;
    width: 100%;
    min-height: var(--environment-banner-height, 32px);
    align-items: center;
    justify-content: center;
    padding: 0.35rem 1rem;
    color: #ffffff;
    box-shadow: 0 1px 3px rgba(17, 24, 39, 0.16);
}

.environment-banner__text {
    display: block;
    max-width: min(100%, 96rem);
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.75rem;
}

.environment-banner-active body {
    padding-top: var(--environment-banner-height, 32px);
}

.environment-banner-active .h-screen {
    height: calc(100vh - var(--environment-banner-height, 32px));
}

.environment-banner-active .min-h-screen {
    min-height: calc(100vh - var(--environment-banner-height, 32px));
}
</style>
